/**
 * Прив’язка полів модуля «connectors» (Інтеграції) до понять довідника (значок «?» біля підпису поля).
 * Ключ — `connectors.<сутність>.<поле>`, значення — термін словника (GET /api/v1/kb/glossary).
 * Мапу підключає координатор у features/knowledge/fieldTerms.ts (FIELD_TERMS).
 * Поле в інтерфейсі: <Field term="connectors.<сутність>.<поле>"> або <Property term="…">.
 */
export const CONNECTORS_FIELD_TERMS: Readonly<Record<string, string>> = {
  // Картка конектора «CRM фірми» (угоди, ОЕ з угоди, передання в роботу) — реквізит «Призначення».
  'connectors.connector.crm': 'CRM',
  // Картка конектора «Управлінський портал» (перенесення з УП).
  'connectors.connector.managementPortal': 'УП',
  // Картка конектора «Фінансова програма pravdopfinance» (графіки ІЦО).
  'connectors.connector.pravdopfinance': 'ІЦО',
  // Google Клас: обліковий запис викладача, від імені якого курси імпортуються в Базу навчання.
  'connectors.google.classroomTeacher': 'Навчання',
};

/** Ключ поняття для реквізиту «Призначення» картки конектора (за ключем конектора каталогу). */
export const CONNECTOR_TERM_KEYS: Readonly<Record<string, string>> = {
  firm_crm: 'connectors.connector.crm',
  kommo: 'connectors.connector.crm',
  management_portal: 'connectors.connector.managementPortal',
  pravdopfinance: 'connectors.connector.pravdopfinance',
};
